"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationType = void 0;
/**
 * This Enum exists for the sole purpose of having an additional column to query against when removing
 * Patient and Provider assets from the Database and Server.
 */
var InformationType;
(function (InformationType) {
    InformationType["Default"] = "null";
    InformationType["PatientImage"] = "patientImage";
    InformationType["PatientCredentials"] = "patientCredentials";
    InformationType["ProviderImage"] = "providerImage";
    InformationType["ProviderCredentials"] = "providerCredentials";
    InformationType["UserImage"] = "userImage";
    InformationType["UserCredentials"] = "userCredentials";
    InformationType["SiteImage"] = "siteImage";
    InformationType["SiteCredentials"] = "siteCredentials";
    InformationType["EobCredentials"] = "eobCredentials";
    InformationType["Logo"] = "logo";
})(InformationType = exports.InformationType || (exports.InformationType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/upload.ts
// module id = 3028
// module chunks = 0